import { z } from "zod"

const RequirementRuleEnum = z.enum([
  "mustInclude",
  "mustNotInclude",
  "mustAsk",
  "mustNotAsk",
  "mustDo",
])

const RequirementPriorityEnum = z.enum(["hard", "soft"])
const RequirementCheckerEnum = z.enum(["llm", "code", "mixed", "none"])
const RequirementSourceTypeEnum = z.enum([
  "system",
  "context",
  "kind",
  "goal",
  "channel",
  "capability",
  "external",
])

const CodeCheckSchema = z.object({
  type: z.enum(["maxLength", "mustContainVerbatim", "mustNotMatch"]),
  value: z.union([z.string(), z.number()]),
})

const RequirementSourceSchema = z.object({
  type: RequirementSourceTypeEnum,
  ref: z.string().optional(),
})

export const RequirementSchema = z.object({
  id: z.string(),
  rule: RequirementRuleEnum,
  description: z.string(),
  priority: RequirementPriorityEnum.optional(),
  checker: RequirementCheckerEnum.optional(),
  source: RequirementSourceSchema,
  codeCheck: CodeCheckSchema.optional(),
})

export const GeneratedRequirementSchema = RequirementSchema.pick({
  rule: true,
  description: true,
}).extend({ description: z.string().trim().min(1) })

export type Requirement = z.infer<typeof RequirementSchema>
export type GeneratedRequirement = z.infer<typeof GeneratedRequirementSchema>
export type RequirementChecker = z.infer<typeof RequirementCheckerEnum>
export type RequirementPriority = z.infer<typeof RequirementPriorityEnum>
export type ResolvedRequirement = Omit<Requirement, "priority" | "checker"> & {
  priority: RequirementPriority
  checker: RequirementChecker
}

export function normalizeRequirementId(id: string) {
  return id.toLowerCase().replace(/[\s_]+/g, "-")
}
